import {Nameable} from "./interface/Nameable";

export class CustomeoCompany implements Nameable {

    constructor(
        public id: number | null,
        public name: string
    ) {
    }
}